import { ref } from 'vue';
import type { Translations } from '../../types/translations';
import { dataFetch } from '../helpers/dataFetch';

const translationsData = ref<Translations>();
const eTagLocalStore = 'store-translations-eTag';
const storeId = 'store-translations';
const languageId = 'store-language';
const languageData = sessionStorage.getItem(languageId);

export const getTranslations = async ({
  caasUrl,
  masterLocale,
  masterProject,
  stage,
  translationsServiceUrl,
  languageLowerCase,
}: {
  caasUrl: string;
  masterLocale: string;
  masterProject: string;
  stage: string;
  translationsServiceUrl: string;
  languageLowerCase: string;
}) => {
  const storedData = sessionStorage.getItem(storeId);
  const eTagExisting = sessionStorage.getItem(eTagLocalStore);

  const url = new URL(translationsServiceUrl, caasUrl)
    .toString()
    .replace('{#masterProject}', masterProject)
    .replace('{#stage}', stage)
    .replace('{#masterLocale}', masterLocale);

  try {
    if (eTagExisting) {
      const response = await fetch(url, {
        headers: {
          'If-None-Match': eTagExisting,
        },
      });
      if (response.status === 304) {
        if (storedData && languageLowerCase === languageData) {
          const parsedData = JSON.parse(storedData);
          translationsData.value = parsedData;
        } else {
          const { data, eTag } = await dataFetch(url);
          translationsData.value = data;

          if (translationsData.value && Object.keys(translationsData.value).length) {
            sessionStorage.setItem(storeId, JSON.stringify(translationsData.value));
          }

          console.debug(
            `${translationsServiceUrl} >>> eTag unchanged: ${eTag}, data fetched due to lack of SessionStorage entry`,
            translationsData.value,
          );
        }
      } else {
        if (!response.ok) {
          throw new Error(`${translationsServiceUrl} >>> error, ${response.status}`);
        }

        const eTag = response.headers.get('Etag');

        if (eTag) {
          sessionStorage.setItem(eTagLocalStore, eTag);
        }

        translationsData.value = await response.json();
        if (translationsData.value && Object.keys(translationsData.value).length) {
          sessionStorage.setItem(storeId, JSON.stringify(translationsData.value));
        }
        console.debug(
          `${translationsServiceUrl} >>> eTag changed, data initialized`,
          translationsData.value,
        );
      }
    } else {
      const { data, eTag } = await dataFetch(url);
      if (eTag) {
        sessionStorage.setItem(eTagLocalStore, eTag);
      }
      translationsData.value = data;
      sessionStorage.setItem(storeId, JSON.stringify(translationsData.value));

      console.debug(
        `${translationsServiceUrl} >>> first eTag, data initialized`,
        translationsData.value,
      );
    }

    return translationsData.value;
  } catch (error) {
    console.error(`${translationsServiceUrl} >>> error`, error);
  }
};
